import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { ErrorMessageResponse } from '../model/error-message-response.model';
import { ErrorMessage } from '../model/error-message.model';
import { ErrorService } from './error.service';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.css']
})

export class ErrorComponent implements OnInit {

  public errorMessage: ErrorMessage;

  constructor(private errorService: ErrorService, private route: ActivatedRoute) { }

  ngOnInit() {
    this.route.paramMap.pipe(
      switchMap((params: ParamMap) => {
        let idError = params.get('idError');
        return of(idError);
      })).subscribe((idError: string) => {
        this.errorMessageById(idError);
      });
  }

  errorMessageById(idMessage: string) {
    this.errorService.getErrorMessage().subscribe(
      (messages: any) => {
        if (messages && messages.errorMessages.length > 0)
          this.errorMessage = messages.errorMessages.filter(message => message.idErrorMessage.toString().includes(idMessage))[0];
      });
  }

  get errorMessageDescription(): string {
    if (this.errorMessage)
      return this.errorMessage.message;
    else
      return "A ação não pode ser completada. Tente novamente em alguns segundos. \n Se o problema persistir, contate seu canal de atendimento.";

  }

}
